export class DezaktywujUzytkownikaModel {
    idUzytkownika: string;
    potwierdzonoDezaktywacje: boolean;
}